import React from 'react';
import styled from 'styled-components';
import Ellipses from '../EllipsesPresets/EllipsesPresets';

const Root = styled.div`
	display: block;
`;

const PersonRoot = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	.userimg {
		display: flex;
		align-items: center;
		justify-content: center;
	}
`;

const PersonDetails = styled.div`
	flex-shrink: 1;
	display: flex;
	flex-direction: column;
	line-height: 1.4;
	margin-left: var(--px-10);
	overflow: hidden;
`;

const Line1 = styled.div`
	font-size: 14px;
	font-weight: 500;
`;

const Line2 = styled.div`
	font-size: 12px;
	font-weight: 300;
`;

const Line3 = styled.div`
	font-size: 12px;
	font-weight: 300;
`;

const PersonNoDataTemplate = (props) => {
	const personProps = props.personProps || {};
	const firstName = personProps.firstName || '';
	const lastName = personProps.lastName || '';
	const emailAddress = personProps.emailAddress || '';
	const userInital = personProps.userInital || '';
	const role = personProps.role || '';

	const initials = firstName ? `${firstName.charAt(0)}${lastName.charAt(0)}` : userInital;
	const fullName = `${firstName} ${lastName}`.trim();

	return (
		<Root className="parent">
			<PersonRoot>
				<section className="pull-left userimghold">
					<span className="userimg bold">{initials}</span>
				</section>
				<PersonDetails className="userInfoDetails">
					<Line1 className="userName">
						<Ellipses.Single tooltip={fullName}>{fullName}</Ellipses.Single>
					</Line1>
					<Line2 className="userEmail">
						<Ellipses.Single tooltip={emailAddress}>{emailAddress}</Ellipses.Single>
					</Line2>
					{role ? (
						<Line3 className="userRole">
							<Ellipses.Single tooltip={role}>{role}</Ellipses.Single>
						</Line3>
					) : null}
				</PersonDetails>
			</PersonRoot>
		</Root>
	);
};

export default PersonNoDataTemplate;
